import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

const Tag = ({
	             text,
	             variant = 'green',
	             size,
	             className
             }) => {
	return (
			<div className={cn('tag', {
				[`tag_variant_${variant}`]: variant,
				[`tag_size_${size}`]: size
			}, className)}
			> {text} </div>
	)
};

Tag.propTypes = {
	text: PT.oneOfType([PT.string, PT.number]),
	variant: PT.oneOf(['blue', 'gray', 'yellow', 'purple', 'red', 'green']),
	size: PT.oneOf(['small', 'medium', 'big']),
	className: PT.string
};

export default Tag;
